var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReportes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21019",
    "data-name": "Grupo 21019",
    transform: "translate(-1274 -397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2070",
    "data-name": "Rect\\xE1ngulo 2070",
    transform: "translate(1274 397)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "chart-svgrepo-com",
    d: "M22.139,14.778v7.361M10.361,14.778v7.361M16.25,10.361V22.139M8.889,29.5H23.611A5.889,5.889,0,0,0,29.5,23.611V8.889A5.889,5.889,0,0,0,23.611,3H8.889A5.889,5.889,0,0,0,3,8.889V23.611A5.889,5.889,0,0,0,8.889,29.5Z",
    transform: "translate(1277.75 400.5)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportes);
export default __webpack_public_path__ + "static/media/icon-reportes.fcc681629eea51d3840d6b943241284d.svg";
export { ForwardRef as ReactComponent };